import script from "./CpitnWhiteCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./CpitnWhiteCard.vue?vue&type=script&lang=ts&setup=true"

import "./CpitnWhiteCard.vue?vue&type=style&index=0&id=5c1116b4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c1116b4"]])

export default __exports__